/**
 * Reconstructs the URL after a frontend-router redirect (see fusion-shell
 * `frontend-router/utils.ts`).
 */
export const reconstructUrl = (
  location: Pick<Location, 'hash' | 'origin' | 'search'>
): URL => {
  const url = new URL(location.origin);

  const searchParams = new URLSearchParams(location.search);
  const originalPath = searchParams.get('originalPath');
  if (originalPath) {
    const [originalPathname, originalSearch] = originalPath.split('?');

    if (originalPathname) {
      url.pathname = originalPathname;
    }

    if (originalSearch) {
      url.search = originalSearch;
    }
  }

  if (location.hash) {
    url.hash = location.hash;
  }

  return url;
};
